module.exports = __webpack_public_path__ + "img/intj.4c9c5070.png";